import React from 'react'
import {Header, Loader, Icon} from 'semantic-ui-react'
import ReactMarkdown from 'react-markdown'
import useSWR from 'swr'
import axios from 'axios'
import {asResponse} from '../../../../util'

const fetcher = async (url) => {
  const resp = await asResponse(axios.get(url))
  return resp.data
}

const CLIOverview = () => {
  const {data, error} = useSWR('https://raw.githubusercontent.com/servicemocks/smocks-cli/master/README.md', fetcher)

  return (
    <div className='doc-section'>
      <Header as='h2'>CLI</Header>
      <p>
        The CLI is another handy tool in the event you'd like to manage mock definitions from a source control repository.
        It intentionally makes commands available to you to push, pull and so on so that you can incorporate them in your
        CI/CD pipeline scripts if you so choose.
      </p>
      <Icon size='large' name='github'/>
      <a href='https://github.com/servicemocks/smocks-cli' target='_blank'>https://github.com/servicemocks/smocks-cli</a>
      {
        !data && (<Loader active inline/>)
      }
      {
        !!data && (<ReactMarkdown source={data} unwrapDisallowed={true}/>)
      }
    </div>
  )
}

export {CLIOverview}

export default CLIOverview